export default __webpack_public_path__ + "static/media/green-check-icon.71795b8f.svg";